export { default as create } from "./Create";
export { default as edit } from "./Edit";
export { default as list } from "./List";
export { default as show } from "./Show";
export const name = "admin/winners-2023";
export const options = {
  label: "Winner News 2023",
};
